export default __webpack_public_path__ + "static/media/white.250a63d7.png";